export default {"src":"/_next/static/media/affordable.4164d85a.svg","height":50,"width":53,"blurWidth":0,"blurHeight":0};